var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"tab-section-nav"},[_c('ul',{staticClass:"tab-section-menu"},_vm._l((_vm.navItems),function(item){return _c('li',{key:item.name},[_c('TabButton',{attrs:{"item":item},on:{"changedTab":_vm.changeTab}})],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }